/* @flow */
import React from "react";
import styled from "styled-components";

import Gettext from "../common/Gettext";
// import AnimationWrapper from "../AnimationWrapper";
import { Row, Input, SelectColor, SelectWidth } from "../Popup";
import ToggleTool from "./ToggleTool";

type Props = {
  indicator: Object,
  activeSelect: String,
  handleClick: Function,
  handleChange: Function
};

const SwitchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
  align-items: center;
  margin: 10px auto 5px;
  color: #99959d;
  direction: ${props => props.theme.direction};
  margin-bottom: 15px;

  @media (min-width: 480px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    margin-bottom: 0px;
  }
  @media (max-width: 479px) {
    padding-top: 15px;
  }
`;

const SwitchHeading = styled.div`
  direction: ${props => props.theme.direction};
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1.5;
  text-align: center;

  @media (min-width: 480px) {
    flex-grow: ${props => props.theme.direction === "ltr" ? 1 : 0};
    text-align: left;
  }
  @media (max-width: 479px) {
    padding-bottom: 15px;
  }
`;

const ToggleWrapper = styled.div`
  flex-grow: ${props => props.theme.direction === "ltr" ? 0 : 1};
`;

export const initialState = {
  fastPeriod: 12,
  slowPeriod: 26,
  period: 9,
  strokeWidth: 2,
  macdWidth: 2,
  color: "#feac00",
  macdColor: "#fe003c",
  likeAPro: true
};

export const indicatorTitle = <Gettext>MACD</Gettext>;

 const MACDPopup = (props: Props) => (
  <Row>
    <Input
      label={<Gettext>Fast MA</Gettext>}
      name="fastPeriod"
      value={props.indicator.fastPeriod}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.fastPeriod}
    />
    <Input
      label={<Gettext>Slow MA</Gettext>}
      name="slowPeriod"
      value={props.indicator.slowPeriod}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.slowPeriod}
    />
    <Input
      label={<Gettext>Signal line</Gettext>}
      name="period"
      value={props.indicator.period}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.period}
    />
    <br />
    <SelectColor
      label={<Gettext>Signal color</Gettext>}
      name="color"
      value={props.indicator.color}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectWidth
      label={<Gettext>Signal width</Gettext>}
      name="strokeWidth"
      value={props.indicator.strokeWidth}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <br />
    <SwitchWrapper>
      <SwitchHeading>
        <Gettext>MACD PRO mode</Gettext>
      </SwitchHeading>
      <ToggleWrapper>
      <ToggleTool value={props.indicator.likeAPro} onChange={() => props.handleAsIsChange({
        target: {
          name: "likeAPro",
          value: !props.indicator.likeAPro
        }
      })} />
      </ToggleWrapper>
    </SwitchWrapper>

    {!props.indicator.likeAPro &&
      <div>
        <SelectColor
          label={<Gettext>MACD color</Gettext>}
          name="macdColor"
          value={props.indicator.macdColor}
          activeSelect={props.activeSelect}
          onClick={props.handleClick}
          onChange={props.handleAsIsChange}
        />
        <SelectWidth
          label={<Gettext>MACD width</Gettext>}
          name="macdWidth"
          value={props.indicator.macdWidth}
          activeSelect={props.activeSelect}
          onClick={props.handleClick}
          onChange={props.handleAsIsChange}
        />
      </div>
    }
  </Row>
);

export default MACDPopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/MACDPopup.js